import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const licenseService = {
  getEntitlement,
  loadLicense,
  activateLicense
}

function getEntitlement () {
  return fetchWrapper.get(apiRoute() + API_V1 + '/license')
}

function loadLicense (license) {
  return fetchWrapper.post(apiRoute() + API_V1 + '/license', license)
}

function activateLicense (licenseId) {
  return fetchWrapper.put(apiRoute() + API_V1 + '/license/' + licenseId, {})
}
